import React, { useState } from 'react';
import Sidebar from 'components/Sidebar';
import MobileHeader from 'components/MobileHeader';
import SearchOverlay from 'components/SearchOverlay';
import Container from 'components/Container';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Link, useNavigate } from 'react-router-dom';
import { createOffice } from 'api/offices';
import TextInput from 'components/Form/TextInput';
import Button from 'components/Button';

export default function OfficesCreate() {

    const [sidebar, setSidebar] = useState(false);
    const [search, setSearch] = useState(false);
    const cache = useQueryClient();
    const navigate = useNavigate();

    const { mutate: create } = useMutation({
        mutationKey: ['createOffice'],
        mutationFn: createOffice,
        onSuccess: (data) => {
            console.log("Office created successfully:", data);
            cache.invalidateQueries(['offices']);

            return navigate(`/settings/offices/${data.data._id}`);
        },
        onError: (error) => {
            console.error("Error creating office:", error);
        }
    });

    function onSubmitHandler(e) {
        e.preventDefault();

        const formData = {
            name: e.target.name.value,
            description: e.target.description.value
        }

        create(formData);
    }


    return (
        <>
            <Sidebar
                visible={sidebar}
                setVisible={setSidebar}
            />

            <SearchOverlay
                visible={search}
                setVisible={setSearch}
            />

            <MobileHeader
                sidebar={sidebar}
                setSidebar={setSidebar}
                search={search}
                setSearch={setSearch}
            />

            <div className={`fixed top-0 w-full bottom-0 transition-all duration-300 ease-in-out lg:pl-[320px] ${sidebar ? 'left-[80vw]' : 'left-0'}`}>
                <Container className='!min-w-[700px] !max-w-[700px]'>
                    <div className='pb-8 pt-20 md:pt-14 text-center'>
                        <p className='text-3xl'>Crea nuovo ufficio</p>
                    </div>

                    <div className=''>
                        <form onSubmit={onSubmitHandler} className='flex flex-col gap-4'>
                            <TextInput
                                label="Nome"
                                name="name"
                                placeholder="Nome"
                            />

                            <TextInput
                                label="Descrizione"
                                name="description"
                                placeholder="Descrizione"
                            />
                            
                            <div className='flex justify-between'>
                                <Link to="/settings/offices" className='hover:bg-verylight text-sm font-medium px-6 py-3 rounded-md transition-colors cursor-pointer duration-200'>Annulla</Link>
                                <Button type="submit">Salva ufficio</Button>
                            </div>
                        </form>
                    </div>

                </Container>
            </div>
        </>
    )
}
